import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 4 }

import { onMounted, ref } from 'vue'
import { businessList, businessDelete, businessDetails } from '@/api/yuntuSales/chanceManage'
import dataConfig from '@/views/yuntuSales/commonEnum/dataConfig'
import BusinessName from '@/components/BusinessName/index.vue'
import Modal from '@/hooks/modalType'
import { useRoute, useRouter } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { BusinessListItem } from '@/typings/api/chanceManage'
import { tableIdByPath } from '@/utils'
import { ParamCodeItem } from '@/typings/common'
import formatThousandSeparator from '@/utils/format'
import { listByParamCodes } from '@/api/common'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'

const __default__ = { name: 'OperationLog' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  returnName: {
    type: String
  }
},
  setup(__props) {

const router = useRouter()
const route = useRoute()
const tableRef = ref()
// const loading = ref(false)

const paramCodeData = ref<{
  lbu_demand_country: ParamCodeItem[]
  lbu_products: ParamCodeItem[]
  lbu_logistics_service_provider: ParamCodeItem[]
}>({
  lbu_demand_country: [], // 目的地国家
  lbu_products: [], // 出货渠道（云途产品）
  lbu_logistics_service_provider: [] // 物流服务商
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_demand_country', 'lbu_products', 'lbu_logistics_service_provider']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
})
const fetch = (queryForm: object, callBack: (res: any) => void) => {
  businessList({
    arkCode: route.query.arkCode as string,
    saleChanceRefId: route.query.cosId as string,
    ...queryForm
  }).then((res) => {
    callBack(res)
  })
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}

// 添加
// const handleAdd = () => {
//   router.push({
//     path: '/lbu/business/add',
//     query: {
//       saleChanceRefId: route.query.cosId,
//       returnPath: route.fullPath
//     }
//   })
// }
// 编辑
const handleEdit = (row: BusinessListItem) => {
  router.push({
    path: '/lbu/business/edit',
    query: {
      id: row.id
    }
  })
}
// 删除
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success('删除商机成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
const columns = ref([
  { title: '商机名称', dataIndex: 'saleChanceName', fixed: 'left' },
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '目的地国家', dataIndex: 'requiredCountry' },
  { title: '云途产品', dataIndex: 'product', width: 150 },
  { title: 'OPR金额', dataIndex: 'planSaleAmount', type: 'money', width: 200, sorter: true },
  { title: 'OPR票数', dataIndex: 'mau', type: 'money', sorter: true },
  { title: 'OCR金额', dataIndex: 'committedSaleAmount', type: 'money', width: 200, sorter: true },
  { title: 'OCR票数', dataIndex: 'committedShipment', type: 'money', sorter: true },
  { title: '商机创建时间', dataIndex: 'createTime', width: 190 },
  { title: '商机状态', dataIndex: 'status', dicData: dataConfig.businessStatusEnum },
  { title: '竞争对手', dataIndex: 'competitors' },
  { title: '剩余变更时间', dataIndex: 'remanentFollowDays', width: 200, sorter: true },
  { title: '最新跟进时间', dataIndex: 'latestFollowTime', width: 190, sorter: true },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', fixed: 'right' }
])
/**
 * 竞争对手序列化
 * @param arr 对手数组
 */
const competitorFormat = (arr: any) => {
  if (!Array.isArray(arr) || !arr?.length) return '--'
  const listEnum = paramCodeData.value.lbu_logistics_service_provider
  const result: string[] = []
  arr.forEach((ele) => {
    const item = listEnum.find((e) => e.id === ele)
    if (item) result.push(item.name as string)
  })
  return result.join('、')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    onFetch: fetch,
    tableId: _unref(tableIdByPath)('business'),
    onMask: showMask,
    ref_key: "tableRef",
    ref: tableRef,
    rowKey: "id"
  }, {
    bodyCell: _withCtx(({ column, record, text }) => [
      (column.dataIndex === 'saleChanceName')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: '/lbu/business/view?id=' + record.id,
            title: record.saleChanceNameByTxt
          }, {
            default: _withCtx(() => [
              text
                ? (_openBlock(), _createBlock(BusinessName, {
                    key: 0,
                    appId: "cos_lbu",
                    value: record.saleChanceName,
                    "onUpdate:value": ($event: any) => ((record.saleChanceName) = $event),
                    label: record.saleChanceNameByTxt,
                    "onUpdate:label": ($event: any) => ((record.saleChanceNameByTxt) = $event)
                  }, null, 8, ["value", "onUpdate:value", "label", "onUpdate:label"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_1, "--"))
            ]),
            _: 2
          }, 1032, ["to", "title"]))
        : _createCommentVNode("", true),
      (column.dataIndex === 'competitors')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(competitorFormat(text) || '--'), 1)
          ], 64))
        : _createCommentVNode("", true),
      (column.dataIndex === 'requiredCountry')
        ? (_openBlock(), _createBlock(ChannelText, {
            key: 2,
            appId: "cos_lbu",
            paramCode: "lbu_demand_country",
            value: text
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (column.dataIndex === 'product')
        ? (_openBlock(), _createBlock(ChannelText, {
            key: 3,
            appId: "cos_lbu",
            paramCode: "lbu_products",
            value: text
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (column.type === 'money')
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(formatThousandSeparator)(text)), 1))
        : _createCommentVNode("", true),
      (column.dataIndex === 'action')
        ? (_openBlock(), _createBlock(_component_MoreButton, { key: 5 }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                workCode: record.dutyBy,
                type: "link",
                onClick: ($event: any) => (handleEdit(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 2
              }, 1032, ["workCode", "onClick"])), [
                [_directive_permission, __props.permissionPage?.edit]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleDelete(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, __props.permissionPage?.del]
              ])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "tableId"]))
}
}

})